import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BTN_PRIMARY, BTN_SECONDARY, H_CLOSE, SECTION_INNER } from '../../shared/ui';
import { RequestTermsNavigation } from '../../shared/navigation';

@Component({
  selector: 'app-cta-v3',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './cta-v3.component.html',
})
export class CtaV3Component {
  private readonly requestTerms = inject(RequestTermsNavigation);

  readonly inner = SECTION_INNER;
  readonly hClose = H_CLOSE;
  readonly btnPrimary = BTN_PRIMARY;
  readonly btnSecondary = BTN_SECONDARY;

  onRequestTerms(): void {
    this.requestTerms.go();
  }
}
